module.exports = __webpack_public_path__ + "static/media/witryna_01_A.c1653c0c.png";